// Standard bet chip denominations used across most games
export const BET_DENOMINATIONS = [1, 2, 5, 10, 50, 100];

// Roulette uses a different chip set
export const ROULETTE_DENOMINATIONS = [1, 5, 10, 100];
